"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.VehicleServiceHistory = void 0;
var _AccordionDrawer = _interopRequireDefault(require("../AccordionDrawer"));
var _jsxRuntime = require("react/jsx-runtime");
const VehicleServiceHistory = function (_ref) {
  let {
    serviceHistoryRecords,
    editUrl = "/drivers/service/add-service-history?serviceId="
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: serviceHistoryRecords.map(function (record, i) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_AccordionDrawer.default, {
        id: "record" + (record.repairNum || i),
        heading: /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          children: [record.date, " (", record.miles, ")"]
        }),
        "data-testid": "VehicleServiceHistory",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            margin: "15px 0px",
            position: "relative"
          },
          children: [record.editId && /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
            style: {
              position: "absolute",
              right: "0"
            },
            href: editUrl + record.editId,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
              children: "EDIT"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
            children: [record.repairNum && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
                children: "REPAIR NUMBER:"
              }), " ", record.repairNum, " ", /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {})]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
              children: "REPORTED BY:"
            }), " ", record.reportedBy]
          }), record.services]
        })
      });
    })
  });
};
exports.VehicleServiceHistory = VehicleServiceHistory;
var _default = exports.default = VehicleServiceHistory;